<template>
    <section>
        <div :class="`notices-wrapper ${note.type}`" v-for="note in $store.getters.notifications.items" v-if="!['validation', 'remove_from_cart', 'all_removed'].includes(note.type) &&
         (!target || target === $store.getters.notifications.target)">
            <div :class="`notice-message ${note.type}`" role="alert" v-html="note.message">
            </div>
        </div>
        <div class="notices-wrapper" v-if="Object.keys(validationErrors).length && (!target || target === $store.getters.notifications.target) && $store.getters.notifications.target != 'dont_show' && $store.getters.notifications.target != 'all_removed'">
            <div :class="`notice-message`" v-for="error in validationErrors" role="alert" v-html="error">
            </div>
        </div>
        <div class="notices-wrapper" v-if="note.type === 'remove_from_cart' && (!target || target === $store.getters.notifications.target)"
             v-for="note in $store.getters.notifications.items">
            <div :class="`notice-message`"  role="alert" >
                Item {{ note.item.title }} removed successfully.
                <a href="javascript:" class="undo_button" @click="undoToCart(note.item)" >Undo</a>
            </div>
        </div>
        <div class="notices-wrapper" v-if="note.type === 'all_removed' && (!target || target === $store.getters.notifications.target)"
             v-for="note in $store.getters.notifications.items">
            <div :class="`notice-message`" role="alert">
                Items removed successfully.
                <a href="javascript:" class="undo_button" @click="undoRemovedItems" >Undo</a>
            </div>
        </div>
    </section>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
export default {
    name: 'notifications',
    props: ['target'],
    computed: {
        ...mapGetters(['validationErrors']),
    },
    methods: {
        ...mapActions(['undoToCart', 'undoRemovedItems'])
    }
}
</script>
<style scoped>
.notices-wrapper {
    background: #fff;
    border-top: 3px solid #b81c23;
    padding: 1em 2em 1em 1em;
    margin-bottom: 15px;
}
</style>
<style>

.notices-wrapper .notice-message strong {
    color: #b81c23 !important;
}
.notices-wrapper .notice-message.success{
    border-top-color: #8fae1b;
}
.notices-wrapper .notice-message.error, .notices-wrapper .notice-message.validation{
    border-top-color: #a46497;
}
.notices-wrapper .notice-message.info{
    border-top-color: #1e85be;
}

.notices-wrapper .notice-message.success a{
   color: #8fae1b;
}
.notices-wrapper .notice-message.error a{
    color: #a46497;
}
.notices-wrapper .notice-message.info a{
    color: #1e85be;
}

.notices-wrapper.success{
    border-top: 3px solid #8fae1b;
}
.notices-wrapper.error{
    border-top: 3px solid #b81c23;
}
.notices-wrapper.info{
    border-top: 3px solid #1e85be;
}
</style>
